module.exports = __webpack_public_path__ + "img/tiers_accountant_create.6c4cf2c2.png";